<template>
  <div class="sidebar">
    <div class="top">
      <b-img-lazy v-if="GET_IS_DARK_MODE" :src="require('@/assets/images/humanify-logo-dark.svg')" />
      <b-img-lazy v-else :src="require('@/assets/images/humanify-logo.svg')" />
    </div>
    <div class="list">
      <ul>
        <li class="for-border" />
        <router-link v-for="(data,index) in sidebar" :key="index" tag="li" class="cursor-pointer" :to="{ name: data.to.name }">
          <div>
            <b-icon :icon="data.icon" class="mr-2" />
            <span>{{data.text}}</span>
          </div>
        </router-link>
        <li class="for-border" />
      </ul>
    </div>
    <div class="bottom">
      <div class="d-flex align-items-center justify-content-between w-100">
        <b-dropdown variant="none" toggle-tag="div" dropup no-caret toggle-class="bg-transparent d-flex align-items-center p-0 border-0">
          <template #button-content>
            <div v-if="GET_USER" class="d-flex align-items-center justify-content-between">
              <b-avatar badge-variant="info">
                <template v-if="GET_USER.role=='admin'" #badge>
                  <b-icon icon="app-star" />
                </template>
              </b-avatar>
              <div :class="{ 'text-white': GET_IS_DARK_MODE, }" class="ml-1" style="text-align: start;">
                <p class="text-decoration-none mb-0">{{GET_USER.first_name}} {{GET_USER.last_name}}</p>
                <span>{{GET_USER.username}}</span>
              </div>
              <div class="ml-1">
                <b-icon icon="caret-up-fill" :variant="GET_IS_DARK_MODE?'white':'black'" />
              </div>
            </div>
          </template>
          <b-dropdown-item @click="LOGOUT()" variant="danger">
            <b-icon-arrow-bar-left />
            Logout
          </b-dropdown-item>
        </b-dropdown>
        <div class="ml-1">
          <b-button variant="link" class="mr-2" @click="CHANGE_THEME()">
            <b-icon v-if="GET_THEME==themes.light.value" icon="sun-fill" />
            <b-icon v-else-if="GET_THEME==themes.dark.value" icon="app-dark-mode" />
            <b-icon v-else icon="circle-half" />
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CHANGE_THEME, GET_IS_DARK_MODE, GET_THEME, GET_USER, LOGOUT } from '@/store/constants'
import { mapGetters } from 'vuex'
import { sidebar, themes } from '@/constants'
import { mapActions } from 'vuex'
export default {
  name: 'Sidebar',
  computed: {
    ...mapGetters([
      GET_USER,
      GET_THEME,
      GET_IS_DARK_MODE,
    ]),
    sidebar(){ return sidebar },
    themes(){ return themes },
  },
  methods: {
    ...mapActions([
      LOGOUT,
      CHANGE_THEME,
    ]),
  },
}
</script>

<style lang="scss" scoped>
@import '~/node_modules/bootstrap/scss/_functions.scss';
@import '~/node_modules/bootstrap/scss/_variables.scss';
.sidebar {
  grid-area: sideBar;
  color: $black;
  padding-left: 15px;
  padding-top: 15px;
  height: calc(100% - 15px - 15px);
  display: flex;
  flex-direction: column;
  > .top {
    height: 50px;
  }
  > .list {
    height: calc(100% - 50px - 70px);
    overflow: auto;
    > ul {
      list-style: none;
      padding: 0px;
      background: linear-gradient(to right,  $light-card 0%, $light-card 50%, $white 50%, $white 100%);
      > li {
        &:not(.router-link-exact-active):hover {
          padding: 2px;
          padding-right: 15px;
          > div {
            background-color: #ffffffaa;
            padding: 8px;
            border-radius: 50px;
          }
        }
        background-color: $light-card;
        padding: 10px;
        &.for-border {
          height: 20px;
        }
        &:has(+ .router-link-exact-active) {
          border-bottom-right-radius: 20px;
        }
        &.router-link-exact-active + li {
          border-top-right-radius: 20px;
        }
        &.router-link-exact-active {
          background-color: $white;
          border-top-left-radius: 25px;
          border-bottom-left-radius: 25px;
        }
      }
    }
  }
  > .bottom {
    height: 70px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    > div {
      background-color: $white;
      padding: 10px;
      border-radius: 10px;
      margin-right: 10px;
    }
  }
}
</style>